<script setup lang="ts">
defineProps<{
  slug: string;
  appartement: StoryblokAppartementContent;
}>();

const localePath = useLocalePath();
</script>

<template>
  <NuxtLink :to="localePath('/' + slug)" class="appartement">
    <BaseImage
      class="appartement__media"
      v-bind="appartement.images[0]"
      aspect-ratio="4/3"
    ></BaseImage>
    <div class="appartement__content">
      <div class="font-optimus sc-h4 mb-2 font-normal">
        {{ appartement.name }}
      </div>
      <p class="appartement-description mb-4">
        {{ appartement.description }}
      </p>
      <div class="appartement-facts">
        <div class="appartement-facts__icons">
          <BaseAppartementIcons
            class="mb-4"
            :is-small="true"
            :has-bathroom="appartement.hasBathroom"
            :has-kitchen="appartement.hasKitchen"
            :has-wlan="appartement.hasWlan"
            :number-of-floors="appartement.numberOfFloors"
            :number-of-people="appartement.numberOfPeople"
          ></BaseAppartementIcons>
        </div>
        <p
          class="appartement-facts__price font-optimus sc-h5 lg:sc-h4 font-normal"
        >
          {{ appartement.price }}
        </p>
      </div>
    </div>
  </NuxtLink>
</template>

<style lang="scss" scoped>
.appartement {
  @apply -m-4;
  display: flex;
  flex-wrap: wrap;

  &__media,
  &__content {
    @apply m-4;
    flex-basis: calc((640px - 100%) * 999);
  }

  &__media {
    min-width: 250px;
    flex-grow: 0;
  }

  &__content {
    flex-grow: 1;
  }
}

.appartement-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.appartement-facts {
  display: flex;
  flex-wrap: wrap;

  &__price {
    flex-shrink: 0;
  }
  &__icons {
    flex-grow: 1;
    flex-basis: calc((480px - 100%) * 999);
  }
}
</style>
